import instance from './axiosConfig';

export default {
    get: function(url, data) {
        return instance({
            url: url,
            method: 'get',
            params: data
        });
    },
    post: function(url, data) {
        return instance({
            url: url,
            method: 'post',
            data: data,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    postsign: function(url, data) {
        return instance({
            url: url,
            method: 'post',
            data: data,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        });
    },
    put: function(url, data) {
        return instance({
            url: url,
            method: 'put',
            data: data
        });
    },
    delete: function(url, data) {
        return instance({
            url: url,
            method: 'delete',
            params: data
        });
    },
    all:function(promises){
      return new Promise((resolve, reject) => {
        axios.all(promises)
          .then(axios.spread((...results) => {
            resolve(results);
          }))
          .catch(error => {
            reject(error);
          });
      });
    }
}
